import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ReportFormValues } from '..';
import { useToast } from '../../../hooks';
import { apiService } from '../../../services/api';
import {
  ReportEntity,
  ReportStatus,
  UpdateReportReq,
} from '../../../services/api.types';
import { Button } from '../../Button';
import { TextArea } from '../../Inputs/TextArea';
import { Modal } from '../../Modal';
import { formRules } from '../../RegisterForm/FormRules';

type ModalReviewReqProps = {
  isAdminOrEmployee: boolean;
  open: boolean;
  onClose: () => void;
  reportInfoId: number | undefined;
  reportDefaultValues: ReportFormValues;
  onUpdate: ((res: ReportEntity) => void) | undefined;
  setDefaultStatus: () => void;
};

export const ModalReviewReq = ({
  isAdminOrEmployee,
  open,
  onClose,
  reportInfoId,
  reportDefaultValues,
  onUpdate,
  setDefaultStatus,
}: ModalReviewReqProps) => {
  const toast = useToast();
  const methods = useForm<ReportFormValues>({
    defaultValues: {
      reviewRequest: reportDefaultValues.reviewRequest,
      status: reportDefaultValues.status,
    },
  });
  const [isUpdatingReport, setIsUpdatingReport] = useState<boolean>(false);
  const handleClose = () => {
    setDefaultStatus();
    onClose();
  };

  const onSubmit = async (data: ReportFormValues) => {
    let request: UpdateReportReq = {};

    if (/^\s*$/.test(data.reviewRequest)) {
      toast.warning('Em branco: escreva uma solicitação ou cancele');
      return;
    } else if (data.reviewRequest === reportDefaultValues.reviewRequest) {
      toast.warning(
        'Texto igual ao anterior: escreva uma nova solicitação ou cancele'
      );
      return;
    } else if (data.reviewRequest !== reportDefaultValues.reviewRequest) {
      toast.hide();
    }
    request = {
      status: data.status,
      reviewRequest: data.reviewRequest,
    };

    setIsUpdatingReport(true);
    await apiService
      .updateReport(Number(reportInfoId), request)
      .then(async (res) => {
        onUpdate?.(res);
        methods.reset(reportDefaultValues);
        toast.success('Notificação enviada!');
        onClose();
      })
      .finally(() => {
        setIsUpdatingReport(false);
      });
  };

  return (
    <Modal
      className="self-center max-w-none width-100vw rounded-full"
      style={{ width: '100 vw', maxWidth: 'none' }}
      open={open}
      onClose={handleClose}
    >
      <div className="p-4">
        {isAdminOrEmployee ? (
          <h4 className="mt-0">
            Este formulário necessita de revisão ou ajustes pelo professor?
          </h4>
        ) : (
          <h4 className="mt-0">
            Professor, este formulário necessita de revisão ou ajustes...
          </h4>
        )}

        <div className="max-w-full m-3 p-4">
          <TextArea
            onChange={(e) => {
              methods.setValue('reviewRequest', e.target.value);
            }}
            label="Notificação para o professor:"
            name={'reviewRequest'}
            disabled={!isAdminOrEmployee}
            placeholder={'Descreva as alterações solicitadas'}
            rules={formRules.reviewRequestRequired}
          />
        </div>

        <div className="flex gap-12 justify-center pt-4 mt-3">
          {isAdminOrEmployee ? (
            <>
              <Button size="small" circular onClick={handleClose}>
                Cancelar
              </Button>
              <Button
                size="small"
                circular
                isLoading={isUpdatingReport}
                onClick={() => {
                  methods.setValue('status', ReportStatus.PENDING);
                  onSubmit(methods.getValues());
                }}
              >
                Enviar notificação
              </Button>
            </>
          ) : (
            <Button circular size="small" onClick={onClose}>
              Ciente
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};
